module.exports = "<div>\n\t<section class=\"sourceErrors__header\">\n\t<section class=\"sourceErrors__title\">Errors</section>\n\t<i class=\"sourceErrors__close icon close-icon\" ng-click=\"vm.closeModal()\"></i>\n</section>\n<div class=\"sourceErrors__preview-section-wrapper\">\n\t<div class=\"source-errors__table-wrapper\">\n\t<table-component columns=\"vm.tab.columns\"  options=\"vm.tab.options\" data=\"vm.data\" ></table-component>\n\t<div class=\"source-errors__table-bottom-bar\"></div>\n</div>\n<errors-legend></errors-legend>\n</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/sourceErrorsModal/sourceErrorsModal.html
// module id = 500
// module chunks = 1